function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 0a9 9 0 019 9c0 7-9 13-9 13S0 16 0 9a9 9 0 019-9zm0 6a3 3 0 100 6 3 3 0 000-6z",
  fillRule: "evenodd",
  fill: "currentColor"
});

function SvgIconMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 22"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkgLjAwMDAwMDEzYzQuOTcwNTYyNyAwIDkgNC4wMjk0MzcxNyA5IDkgMCA2Ljk5OTk5OTk3LTkgMTIuOTk5OTk5OTctOSAxMi45OTk5OTk5N3MtOS02LTktMTIuOTk5OTk5OTdjMC00Ljk3MDU2MjgzIDQuMDI5NDM3My05IDktOXptMCA1Ljk5OTk5OTg3Yy0xLjY1Njg1NDI1IDAtMyAxLjM0MzE0NTc1LTMgMyAwIDEuNjU2ODU0MiAxLjM0MzE0NTc1IDMgMyAzIDEuNjU2ODU0MiAwIDMtMS4zNDMxNDU4IDMtMyAwLTEuNjU2ODU0MjUtMS4zNDMxNDU4LTMtMy0zeiIgZmlsbC1ydWxlPSJldmVub2RkIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";
export { SvgIconMarker as ReactComponent };